import { HttpResult } from 'widgets-for-react'
import { Location, LocationExpandableKind } from './locationExpandableBlockState'
import { List } from 'immutable'

type LocationData = {
  Location: {
    Title: string
    Path: string
  }
  Clinics: {
    Kind: 'Polikliniek' | 'Verpleegafdeling'
    PhoneNumber: Array<{
      PhoneNumber: string
    }>
    OpeningTime: string
    Title: string
    Route: string
    VisitTime: string
  }[]
}[]

export const locationExpandableBlockApi = async (
  kind: LocationExpandableKind, 
  id: number
): Promise<HttpResult<List<Location>>> => {
  const res = await fetch(`/api/v1/locations/${kind}/${id}`)
  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const locations: LocationData = await res.json()
  return {
    kind: 'result',
    status: 200,
    value: List(
      locations.map((location) => ({
        title: location.Location.Title,
        slug: location.Location.Path,
        expanded: false,
        clinics: location.Clinics.map((item) => ({
          kind: item.Kind,
          title: item.Title,
          phoneNumber: (item.PhoneNumber ?? []).map(x=>x.PhoneNumber),
          openingTimes: item.OpeningTime,
          visitingTimes: item.VisitTime,
          route: item.Route,
        })),
      }))
    ),
  }
}